<template>
  <div class="second-layout">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css"
      integrity="sha256-h20CPZ0QyXlBuAw7A+KluUYx/3pK+c7lYEpqLTlxjYQ="
      crossorigin="anonymous"
    />
    <v-container class="vacancy-wrapper">
      <v-row>
        <v-col cols="12" class="col vacancy-content" xl="8">
          <v-breadcrumbs
            v-if="breadcrumbItems"
            :items="breadcrumbItems"
            class="px-0 mt-8 mb-10"
          ></v-breadcrumbs>
          <h1>
            {{
              vacancyData
                ? vacancyData.vacancy_title
                : vacancy
                ? vacancy[0].title
                : 'Carregando...'
            }}
          </h1>
          <div class="social-share-wrapper">
            <h3>Compartilhe essa vaga:</h3>
            <ShareNetwork
              v-for="network in networks"
              :key="network.network"
              rel="nofollow noopener noreferrer"
              :network="network.network"
              :style="{ backgroundColor: network.color }"
              :url="urlToShare"
              :title="
                vacancyData
                  ? vacancyData.vacancy_title
                  : vacancy
                  ? vacancy[0].title
                  : 'Carregando...'
              "
              :description="
                vacancyData
                  ? vacancyData.description
                  : vacancy
                  ? vacancy[0].job_description
                  : 'Carregando...'
              "
              twitter-user="seloeureciclo"
            >
              <span>{{ network.name }}</span>
              <i :class="network.icon" />
            </ShareNetwork>
          </div>
          <div
            v-html="
              vacancyData
                ? vacancyData.description
                : vacancy
                ? vacancy[0].job_description
                : 'Carregando...'
            "
          ></div>
          <div
            v-if="commonText"
            v-html="
              commonText
                ? commonText
                : vacancyData.common_text
                ? vacancyData.common_text
                : 'Carregando...'
            "
          ></div>
        </v-col>
        <v-col
          v-if="vacancyData || subscriptionLink"
          cols="12"
          xl="4"
          class="col subscribe-wrapper"
        >
          <h2>Inscreva-se:</h2>
          <iframe
            width="100%"
            height="100%"
            src="https://app.pipefy.com/public/form/1o6lUBGT?embedded=true"
            frameborder="0"
          ></iframe>
          <div v-show="false" class="btn-wrapper">
            <v-btn
              rounded
              large
              class="green accent-1 black--text pa-8"
              :href="
                vacancyData
                  ? vacancyData.subscription_link.url
                  : subscriptionLink.url
              "
              target="_blank"
            >
              {{
                vacancyData
                  ? vacancyData.subscription_link.title
                    ? vacancyData.subscription_link.title
                    : 'Inscreva-se'
                  : subscriptionLink && subscriptionLink.title !== ''
                  ? subscriptionLink.title
                  : 'Inscreva-se'
              }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
    vacancyData: null,
    networks: [
      {
        network: 'facebook',
        name: 'Facebook',
        icon: 'fab fah fa-lg fa-facebook-f',
        color: '#1877f2',
      },
      {
        network: 'linkedin',
        name: 'LinkedIn',
        icon: 'fab fah fa-lg fa-linkedin',
        color: '#007bb5',
      },
      {
        network: 'whatsapp',
        name: 'Whatsapp',
        icon: 'fab fah fa-lg fa-whatsapp',
        color: '#25d366',
      },
    ],
  }),
  computed: {
    ...mapState(['wordpress']),
    subscriptionLink() {
      if (this.wordpress && this.wordpress.pipefyLink) {
        return this.wordpress.pipefyLink;
      }
      return null;
    },
    vacancy() {
      if (this.wordpress && this.wordpress.vacancies) {
        return this.wordpress.vacancies.filter(vacancy => {
          if (
            vacancy.title.replace(/[^A-Z0-9]+/gi, '-').toLowerCase() ===
            this.$route.params.slug
          ) {
            return vacancy;
          }
          return false;
        });
      }
      return null;
    },
    breadcrumbItems() {
      if (this.vacancy) {
        const items = [];
        items.push(
          {
            text: 'Trabalhe Conosco',
            disabled: false,
            href: '/trabalhe-conosco',
          },
          {
            text: this.vacancy[0] ? this.vacancy[0].title : 'Carregando...',
            disabled: true,
          },
        );
        return items;
      }
      return null;
    },
    urlToShare() {
      return `${window.location.origin}${this.$route.fullPath}`;
    },
    commonText() {
      if (this.wordpress && this.wordpress.commonText) {
        return this.wordpress.commonText;
      }
      return null;
    },
  },
  beforeMount() {
    this.$store.dispatch('fetchData');
    if (this.$route.params && this.$route.params.data) {
      this.vacancyData = this.$route.params.data;
    }
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.vacancy-wrapper
  padding-bottom: 100px
  h1
    text-transform: uppercase
    margin-bottom: 25px
    @media screen and (min-width: $md)
      font-size: 2.5rem
      margin-bottom: 20px
  .social-share-wrapper
    display: flex
    align-items: center
    flex-direction: row
    flex-wrap: wrap
    justify-content: flex-start
    margin-bottom: 30px
    h3
      margin-right: 20px
      @media screen and (max-width: $sm)
        flex: 100%
    a[class^="share-network-"]
      text-decoration: none
      color: #ffffff
      flex: none
      border-radius: 100%
      overflow: hidden
      display: flex
      flex-direction: row
      align-content: center
      align-items: center
      cursor: pointer
      margin: 0 10px 0 0
      span
        display: none
      .fah
        background-color: rgba(0, 0, 0, 0.2)
        justify-content: center
        align-items: center
        display: flex
        padding: 10px
        flex: 0 1 auto
        min-width: 42px
        min-height: 42px
  .vacancy-content
    flex: 1
  .subscribe-wrapper
    position: relative
    @media screen and (min-width: $md)
      padding-top: 140px
      max-width: 420px
    iframe
      min-height: 1100px
    .btn-wrapper
      @media screen and (min-width: $md)
        position: fixed
        width: 100%
      .v-btn
        color: #000 !important
        font-size: 2rem
::v-deep
  .responsive-container
    position: relative
    padding-bottom: 50.25%
    padding-top: 30px
    height: 0
    overflow: hidden
    margin-top: 1em
    margin-bottom: 2em
    iframe
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%

.new-color
  .vacancy-wrapper
    font-family: 'metropolisregular', sans-serif !important
    color: #003036
    .subscribe-wrapper
      .btn-wrapper
        .v-btn
          color: #003036 !important
    .social-share-wrapper
      a[class^="share-network-"]
        .fah
          background-color: rgba(0, 48, 54, 0.2)
</style>
